import axios from "axios";
import { post, get, ax } from "./http";

export default {
  // 获取轮播列表
  getBanner(params = {}) {
    return get<{
      content: string;
    }>("https://gw.n8n8.cn/uportrait/api/v1/pd/list", params);
  },

  // 获取投顾列表
  getCustomer(top = 1, limit = 100, page = 1) {
    return get<{
      content: string;
    }>("https://gw.n8n8.cn/n8sf/app/jz/v1/adviser/lists", {
      top,
      limit,
      page
    });
  },

  // 获取动态列表
  getArticle(limit = 10, page = 1) {
    return get<{
      content: string;
    }>("https://gw.n8n8.cn/n8sf/app/jz/v1/article/lists", {
      category: 1,
      limit,
      page
    });
  },

  // 获取文章详情
  getContent(id) {
    return get<{
      content: string;
    }>("https://gw.n8n8.cn/n8sf/app/jz/v1/article/detail", {
      id
    });
  },

  // 提交反馈
  submitFeedback(name, mobile, message) {
    return post<{
      content: string;
    }>("https://gw.n8n8.cn/n8sf/app/jz/v1/message/send", {
      type: 1,
      name,
      mobile,
      message
    });
  },

  // 获取部门列表（含岗位数量）
  getDepartment(page = 1, limit = 1, position_type) {
    return get<{
      content: string;
    }>("https://gw.n8n8.cn/www/api/v1/recruit/department/list", {
      page,
      limit,
      is_valid: 1,
      position_type
    });
  },

  // 获取取职位列表
  getPosition(page = 1, limit = 50, type, department_id, name?) {
    return get<{
      content: string;
    }>("https://gw.n8n8.cn/www/api/v1/recruit/position/list", {
      page,
      limit,
      type,
      department_id,
      name
    });
  },

  // 职位详情
  getJobDetails(id) {
    return get<{
      content: string;
    }>("https://gw.n8n8.cn/www/api/v1/recruit/position/detail", {
      id
    });
  },

  // 获取部门列表（全部）
  getAllDepartment() {
    return get<{
      content: string;
    }>("https://gw.n8n8.cn/www/api/v1/recruit/department/option-list", {
      is_valid: 1
    });
  },

  // 获取小程序短链接
  getGenerateUrlLink(query) {
    return post<{
      content: string;
    }>("https://gw.n8n8.cn/wechat/api/v2/minp/serve/generate-url-link", {
      name: "duanxianwang",
      page: "/pages/preview1/index",
      query: `code=${query}`,
      out_date_num: 1
    });
  },

  // 文件上传-获取七牛密钥
  getUploadToken(key) {
    return get<{
      content: string;
    }>("https://gw.n8n8.cn/n8sf/app/v1/qiniu/token", {
      key
    });
  },

  // 文件上传-上传七牛文件
  postUploadFile(data) {
    return ax.post("https://upload.qiniup.com", data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  // 简历投递
  getDeliver(name, phone, position_id, resume_file) {
    return post<{
      content: string;
    }>("https://gw.n8n8.cn/www/api/v1/recruit/resume/deliver", {
      name,
      phone,
      position_id,
      resume_file
    });
  },

  ax: ax,
  axios: axios
};



// WEBPACK FOOTER //
// ./src/api/index.ts